module.exports = __webpack_public_path__ + "img/levelup-products-circle.4212c4e8.svg";